var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.445 3h-22A2.444 2.444 0 0 0 3 5.444v14.667a2.444 2.444 0 0 0 2.444 2.445H27.445a2.444 2.444 0 0 0 2.444-2.445V5.444A2.445 2.445 0 0 0 27.445 3z",
    fill: "#EDE3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.444 27.445h22.778m-6.11-4.89v4.89M5.443 3h22a2.445 2.445 0 0 1 2.445 2.444v14.667a2.444 2.444 0 0 1-2.444 2.445H5.444A2.444 2.444 0 0 1 3 20.11V5.444A2.444 2.444 0 0 1 5.444 3z",
    stroke: "#500D76",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.143 11.556h-8.73c-.965 0-1.746.766-1.746 1.71v13.69c0 .945.781 1.71 1.746 1.71h8.73c.964 0 1.746-.765 1.746-1.71v-13.69c0-.944-.782-1.71-1.746-1.71z",
    fill: "#EDE3F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.778 25.244h.008M8.413 11.556h8.73c.964 0 1.746.766 1.746 1.71v13.69c0 .945-.782 1.71-1.746 1.71h-8.73c-.965 0-1.746-.765-1.746-1.71v-13.69c0-.944.781-1.71 1.746-1.71z",
    stroke: "#500D76",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 25.276,
    r: 0.5,
    fill: "#510C76",
    stroke: "#510C76",
    strokeWidth: 0.931
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientDashboard);
export default __webpack_public_path__ + "static/media/clientDashboard.9e057214581292fa2a7935d283e88ce5.svg";
export { ForwardRef as ReactComponent };